import { lazy } from 'react'

export const BellyTypeV1 = lazy(() => import('./BellyTypeV1'))
